import { SnowflakeSource } from './snowflake.copysource';
import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';

import { SnowflakeV2TableDataset } from '../dataset/snowflake-v2.dataset';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.snowflakeV2CopySource,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SnowflakeV2TableDataset) }
})
export class SnowflakeV2Source extends SnowflakeSource {
    public static readonly MODEL: IModel;
    public static readonly TREAT_DECIMAL_AS_STRING: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.TreatDecimalAsString,
        association: 'TREAT_DECIMAL_AS_STRING',
        templatable: true
    })
    public treatDecimalAsString?: boolean = false;
}
